import { render, staticRenderFns } from "./WhoWeAreMenu.vue?vue&type=template&id=7e231721&scoped=true&"
import script from "./WhoWeAreMenu.vue?vue&type=script&lang=js&"
export * from "./WhoWeAreMenu.vue?vue&type=script&lang=js&"
import style0 from "./WhoWeAreMenu.vue?vue&type=style&index=0&id=7e231721&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e231721",
  null
  
)

export default component.exports